import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  getJournal,
  getExamData,
  setEdit,
  selectStudent,
  getAttendance,
  setSelectedId,
  setTabValue,
} from "../../services/journalSlice";
// import { useNavigate } from "react-router-dom";

const JournalSummary = () => {
  const dispatch = useDispatch();

  const statefulSelector = useSelector(({ JournalApp }) => JournalApp.journal);
  const { journal } = statefulSelector;
  const { Exams } = statefulSelector.examData;
  const studentList = statefulSelector.studentData.course;

  useEffect(() => {
    if (statefulSelector.selectedClass !== null) {
      dispatch(getExamData());
      dispatch(getJournal());
      dispatch(getAttendance());
    }
  }, [dispatch, statefulSelector.selectedClass, statefulSelector.edit]);

  // const navigate = useNavigate();

  return (
    <>
      {statefulSelector.selectedClass !== null && (
        <div className="mt-4 h-full w-full overflow-x-scroll p-4">
          {journal.course.length !== 0 ? (
            <table
              className="mb-4  h-max w-full border"
              variant="simple"
              color="gray-500"
              mb="24px"
            >
              <thead>
                <tr>
                  <th className="border-b border-l border-gray-200 pb-[10px] text-center  font-bold  text-gray-600 dark:!border-navy-700">
                    №
                  </th>
                  <th className="border-b border-l border-gray-200 pb-[10px]  text-center  text-gray-600 dark:!border-navy-700">
                    Нэр
                  </th>

                  {Exams.length !== 0 &&
                    Exams.map((item, index) => {
                      return (
                        <th
                          key={"exam-name-" + index + 1}
                          className="border-b border-l border-gray-200 pb-[10px]  text-center  text-gray-600 dark:!border-navy-700"
                        >
                          {item.exam_name}
                        </th>
                      );
                    })}
                  <th className="border-b border-l border-gray-200 pb-[10px]  text-center  text-gray-600 dark:!border-navy-700">
                    Оролцоо
                  </th>
                  <th classname="border-b border-l border-gray-200 pb-[10px]  text-center  text-gray-600 dark:!border-navy-700">
                    Ирц
                  </th>
                  <th classname="border-b border-l border-gray-200 pb-[10px]  text-center  text-gray-600 dark:!border-navy-700">
                    Нийт
                  </th>
                </tr>
              </thead>
              <tbody>
                {journal.course.length !== 0 &&
                  journal.course.map((item, value) => {
                    return (
                      <tr key={"exam-result-" + value + 1}>
                        <td className="border-b p-1 text-center font-bold text-gray-600">
                          {value + 1}
                        </td>
                        <td className="border-b border-l border-gray-200 pl-[10px]">
                          {item.firstname + " " + item.lastname}
                        </td>

                        {Exams.length !== 0 &&
                          Exams.map((exam, index) => {
                            return (
                              <td
                                key={"exam-value-" + index}
                                className="border-b border-l border-gray-200 pl-[10px] text-center"
                              >
                                {item.student_exam.filter(
                                  (examEval) => exam.id === examEval.exam
                                )[0]?.point || 0}
                              </td>
                            );
                          })}
                        <td
                          className="border-b border-l border-gray-200 pl-[10px] text-center"
                          onClick={() => {
                            dispatch(selectStudent(value));
                            dispatch(setEdit(true));
                            dispatch(
                              setSelectedId(
                                item.student_additional[0]?.id || -1
                              )
                            );
                          }}
                        >
                          {item.student_additional[0]?.point || 0}
                        </td>
                        <td className="border-b border-l border-gray-200 pl-[10px] text-center">
                          {studentList.length !== 0 &&
                            studentList
                              .filter((student) => student.id === item.id)[0]
                              ?.student_to_attendance_record.filter(
                                (item) => item.status === 3
                              ).length}
                        </td>
                        <td
                          className="border-b border-l border-gray-200 pl-[10px] text-center"
                          onClick={() => {
                            dispatch(selectStudent(value));
                            dispatch(setTabValue(3));
                            dispatch(setEdit(true));
                            dispatch(
                              setSelectedId(item.final_point[0]?.id || -1)
                            );
                          }}
                        >
                          {item.final_point[0]?.point | 0}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          ) : (
            <div
              className="w-full text-center font-poppins font-bold"
              style={{
                height: "300px",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              Хоосон байна
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default JournalSummary;
